import {ENDPOINT, METHOD} from '@/constants';
import {DTO} from '@/shared/base/dto';
import { IQueryGetTemplate } from '@/types';

export class DocumentSetDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.DOCUMENT_SET;
  public method = METHOD.POST;
  public query: undefined;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(public body: any) {
    super();
  }
}

export class GetListDocumentSetDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.DOCUMENT_SET;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  public query: undefined;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(query: any) {
    super();
    this.query = query;
  }
}

export class GetAllListDocumentSetDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.DOCUMENT_SET_ALL;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  public query: IQueryGetTemplate;

  constructor(query: IQueryGetTemplate) {
    super();
    this.query = query;
  }
}

export class DeleteDocumentSetDTO extends DTO {
  public param: {id: number} | undefined;
  public url = ENDPOINT.DETAIL_DOCUMENT_SET;
  public method = METHOD.DELETE;
  public body: undefined;
  public readonly responseClass: unknown;
  public query: undefined;
  constructor(param: {id: number}) {
    super();
    this.param = param;
  }
}

export class UpdateDocumentSetDTO extends DTO {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public body: any;
  public url: string = ENDPOINT.DETAIL_DOCUMENT_SET;
  public method = METHOD.PUT;
  public param: {id: number | undefined};
  public query: undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(param: {id: number | undefined}, body: any) {
    super();
    this.param = param;
    this.body = body;
  }
}

export class DetailDocumentSetDTO extends DTO {
  public param: {id: number} | undefined;
  public url = ENDPOINT.DETAIL_DOCUMENT_SET;
  public method = METHOD.GET;
  public body: undefined;
  public readonly responseClass: unknown;
  public query: undefined;
  constructor(param: {id: number}) {
    super();
    this.param = param;
  }
}
